<template>
    <!-- 最新资讯 -->
    <section class="home-latest-news">
        <header class="home-latest-news-title">
            <p>最新资讯</p>
            <p>The latest information</p>
        </header>
        <footer class="home-latest-news-content">
            <div class="content-left">
                <div class="content-left-img">
                    <img src="@/assets/webImg/home/swiper1.png" alt="">
                </div>
                <div class="content-left-text">
                    （北京）2020年我国上调退休人员基本养老金
                </div>
            </div>
            <div class="content-right">
                <section class="content-right-column">
                    <p>(北京)2020年我国上调退休人员基本养老金</p>
                    <p>2020年我国上调退休人员基本养老金</p>
                </section>
                <section class="content-right-column">
                    <p>(北京)加大宏观政策实施力度 着力稳企业保就业</p>
                    <p>看图解读：加大宏观政策实施力度 着力稳企业保就业</p>
                </section>
                <section class="content-right-column">
                    <p>(北京)“五一”放假4天！</p>
                    <p>经国务院批准，现将调整2019年劳动节放假通知安排如下： 2019年5月1日至4日放假调休，共4天。4月28日（星期日）、5月5日（星期日）上班。</p>
                </section>
                <section class="content-right-column">
                    <p>(北京)加大宏观政策实施力度 着力稳企业保就业</p>
                    <p>看图解读：加大宏观政策实施力度 着力稳企业保就业</p>
                </section>
                <section class="content-right-column">
                    <p>(北京)加大宏观政策实施力度 着力稳企业保就业</p>
                    <p>看图解读：加大宏观政策实施力度 着力稳企业保就业</p>
                </section>
            </div>
        </footer>
    </section>
</template>

<script>


export default {

	data() {
		return {}
	},

	computed: {},

	created() {},

    methods: {}

}
</script>

<style lang="scss" scoped>
/** 优势特点 */
.home-latest-news {
    margin: 0 1.60rem;
    margin-top: 60px;

    .home-latest-news-title {
        text-align: center;
        p:first-child {
            font-size: 40px;
            line-height: 56px;
            color: #363636;
        }
        p:last-child {
            font-size: 33px;
            color: #B5B5B5;
            line-height: 46px;
        }
    }

    .home-latest-news-content {
        margin-top: 50px;
        display: flex;
        .content-left {
            position: relative;
            width: 780px;
            height: 588px;
            .content-left-img {
                width: 100%;
                height: 100%;
                img {width: 100%; height: 100%;}
            }
            .content-left-text {
                position: absolute;
                bottom: 12px;
                left: 12px;
                width: 754px;
                height: 92px;
                font-size: 33px;
                color: #fff;
                line-height: 92px;
                background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
                border-radius: 10px;
                opacity: 0.32;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .content-right {
            margin-left: 20px;
            flex: 1;
            .content-right-column {
                &::before {
                    content: '';
                    display: block;
                    width: 100%;
                    height: 2px;
                    margin-bottom: 20px;
                    background: #EEEEEE;
                }
                p:first-child {
                    font-size: 24px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 33px;
                }
                p:last-child {
                    font-size: 20px;
                    color: #999999;
                    line-height: 28px;
                    padding: 14px 0 25px;
                }
            }
            .content-right-column:first-child {
                &::before {
                    display: none;
                }
            }
        }
    }
}

</style>
